// extracted by mini-css-extract-plugin
module.exports = {"blockContainer":"_3hAZK","block":"_1f4Lx","root":"_28uwx"};